import { Container, HoverElement, ToolTipBox } from './ToolTip.styles';
import React from 'react';

export interface ToolTipProps {
  text: string | React.JSX.Element;
  children?: React.ReactNode;
  position?: {
    top?: string;
    right?: string;
    bottom?: string;
    left?: string;
  };
  width?: string;
  innerRef?: React.RefObject<HTMLDivElement | null>;
}

export const ToolTip = ({
  text,
  children,
  position,
  width,
  innerRef,
}: ToolTipProps) => {
  return (
    <Container>
      <HoverElement ref={innerRef}>{children}</HoverElement>
      <ToolTipBox position={position} width={width}>
        {text}
      </ToolTipBox>
    </Container>
  );
};
